import React, { useRef, useState, useEffect } from 'react'
import { TextLink } from '../../typography/TextLink/TextLink'
import { StyledVideoPlayerDescriptionMoreLess } from '../VideoPlayer/VideoPlayer.styled'
import {
    StyledProfileLinkContainer,
    StyledProfileLink,
    StyledVideoPlayerDescriptionMoreLessButton,
} from './VideoHubVideoSkinV2.styled'
import { Profile } from 'web-common'

export const SevenVideoDescription: React.FC<{
    description: string
    showMore: boolean
    showMoreHandler: () => void
}> = ({ description, showMore, showMoreHandler }) => {
    const containerRef = useRef<HTMLDivElement>(null)
    const [maxChars, setMaxChars] = useState(100)
    const [des, setDes] = useState(
        getVideoPlayerDescriptionWithLinks(description),
    )

    useEffect(() => {
        const calculateMaxCharacters = () => {
            if (containerRef.current) {
                const containerWidth = containerRef.current.offsetWidth
                const charWidth = 10
                const maxCharactersPerLine = Math.floor(
                    containerWidth / charWidth,
                )
                const maxCharacters = maxCharactersPerLine * 2
                setMaxChars(maxCharacters - 12)
            }
        }

        calculateMaxCharacters()
        window.addEventListener('resize', calculateMaxCharacters)
        return () => {
            window.removeEventListener('resize', calculateMaxCharacters)
        }
    }, [])
    useEffect(() => {
        setDes(
            getVideoPlayerDescriptionWithLinks(
                showMore ? description.slice(0, maxChars) : description,
            ),
        )
    }, [showMore, description, maxChars])

    return (
        <StyledVideoPlayerDescriptionMoreLess ref={containerRef}>
            {des}{' '}
            {description.length > maxChars && (
                <StyledVideoPlayerDescriptionMoreLessButton
                    onClick={showMoreHandler}
                >
                    {showMore ? '...view more' : ' view less'}
                </StyledVideoPlayerDescriptionMoreLessButton>
            )}
        </StyledVideoPlayerDescriptionMoreLess>
    )
}

function getVideoPlayerDescriptionWithLinks(description: string) {
    const doc = new DOMParser().parseFromString(description, 'text/html')
    const mappedTextWithLinkComponents = [...doc.body.childNodes].map(
        (el, i) => {
            if (el.nodeName === 'A') {
                const linkNode = el as HTMLAnchorElement
                return (
                    <TextLink
                        key={i}
                        href={linkNode.href}
                        openInNewWindow={true}
                    >
                        {linkNode.textContent}
                    </TextLink>
                )
            } else {
                return el.textContent
            }
        },
    )

    return <React.Fragment>{mappedTextWithLinkComponents}</React.Fragment>
}

export const SevenVideoProfileLink: React.FC<{
    profiles: Profile[] | undefined
}> = ({ profiles }) => {
    return (
        <StyledProfileLinkContainer>
            {profiles && profiles.length > 0 ? (
                <>
                    {profiles.map((profile, i, arr) => {
                        const hasMoreProfileLinks = arr.length > i + 1
                        return (
                            <>
                                <StyledProfileLink
                                    to={'/profile/' + profile.slug}
                                    key={i}
                                >
                                    {i === 0 && 'By '}
                                    {`${profile.name}`}
                                </StyledProfileLink>
                                {hasMoreProfileLinks && ' & '}
                            </>
                        )
                    })}
                </>
            ) : (
                'By Digital Team'
            )}
        </StyledProfileLinkContainer>
    )
}
